import * as types from "../constants/ActionConstants";

const initialState = {
    showMenu: false,
    showModallogin: false,
    showToast: false,
    messageToast: "",
    showLoader: false
};

const UI = (state = initialState, action) => {
    const { payload } = action;
    switch (action.type) {
        case types.UI_MENU_SHOW:
            return { ...state, showMenu: true };
        case types.UI_MENU_HIDE:
            return { ...state, showMenu: false };
        case types.UI_MODAL_LOGIN_SHOW:
            return { ...state, showModallogin: true };
        case types.UI_MODAL_LOGIN_HIDE:
            return { ...state, showModallogin: true };
        case types.UI_TOAST_UPDATE_SHOW:
            return { ...state, showToast: true, messageToast: payload };
        case types.UI_TOAST_UPDATE_HIDE:
            return { ...state, showToast: false };
        case types.UI_LOADER_SHOW:
            return { ...state, showLoader: true };
        case types.UI_LOADER_HIDE:
            return { ...state, showLoader: false };

        default:
            return state;
    }
}

export default UI;